import React, { useEffect, useState } from 'react';
import { firebaseApp, auth } from '../../services/firebase'
import { signInWithEmailAndPassword } from "firebase/auth";
import Styles from './styles/UserLogin.module.scss'
import CustomTextField from '../../components/general/CustomTextField'
import CustomButtonContained from '../../components/general/CustomButtonContained'
import Helpers from '../../utils/helpers'
import { useSelector } from "react-redux";
import { useNavigate } from 'react-router-dom'
import Colors from '../../config/colors'
import PositionedSnackbar from "../../components/general/PositionedSnackbar";
import { addUser } from '../../redux/slices/userSlice'
import { useDispatch } from 'react-redux'
import Config from '../../config'
import DDELogo from '../../assets/images/new_logo.png'
import CustomLoaderSpinner from "../../components/general/CustomLoaderSpinner";
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';


export default function UserLogin() {
	let dispatch = useDispatch()
	let navigate = useNavigate()

	const [loading, setLoading] = useState(false)
	const [email, setEmail] = useState('')
	const [password, setPassword] = useState('')
	const [showError, setShowError] = useState(false)
	const [errorMessage, setErrorMessage] = useState('')
	const [showPassword, setShowPassword] = useState(false)


	const user = useSelector(state => {
		// console.log('inside home selector', state.user)
		return state.user
	})

	useEffect(() => {
		if (user.user)
			navigate('/home/work-orders')
	}, [user])

	const onSubmitClicked = () => {
		if (!password || password.length === 0 || !email || email.length === 0) {
			setShowError(true)
			setErrorMessage('Please enter a valid email and password')
			return
		}

		if (!Helpers.validateEmail(email)) {
			setShowError(true)
			setErrorMessage('Please enter a valid email')
			return
		}

		setLoading(true)

		signInWithEmailAndPassword(auth, email, password)
			.then((userCredential) => {
				// Signed in
				const user = userCredential.user;
				Helpers.updateUserStore(user)
				setLoading(false)
			})
			.catch((error) => {
				let errorCode = error.code
				setShowError(true)
				console.log('firebase auth error', error)
				if (errorCode === 'auth/user-not-found') {
					setErrorMessage('Account not found')
				} else if (errorCode === 'auth/wrong-password') {
					setErrorMessage('Wrong password')
				} else if (errorCode === 'auth/invalid-credential') {
					setErrorMessage('Invalid Credentials')
				} else {
					setErrorMessage('Unknown error')
				}
				setLoading(false)
			});

	}

	if(loading) {
		return (
			<div style={{ height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
				<CustomLoaderSpinner />
			</div>
		)
	}

	return (
		<main>
			<div className={Styles.container} style={{ backgroundColor: Colors.backgroundColor }}>
				<PositionedSnackbar
					onClose={() => {
						setShowError(false)
						setErrorMessage('')
					}}
					severity={'error'}
					openFlag={showError}
					message={errorMessage}
				/>

				<p style={{ fontWeight: 'bold', fontSize: 50, marginTop: 80 }}>LendCo</p>
				{/*<img*/}
				{/*	style={{marginTop: 50}}*/}
				{/*	className={Styles.logo}*/}
				{/*	src={DDELogo} height={200} width={300} />*/}

				<div className={Styles.formContainer}>
					<CustomTextField
						value={email}
						onChange={(text) => setEmail(text)}
						label={'Email'} />
					<div style={{width: '100%', display: 'flex', position: 'relative'}}>
						<CustomTextField
							type={showPassword ? 'default' : 'password'}
							value={password}
							onChange={(text) => setPassword(text)}
							label={'Password'} />

						<VisibilityOffIcon onClick={() => setShowPassword(!showPassword)}
							                   style={{color: showPassword ? 'gray' : Colors.theme, position: 'absolute', right: 10, width: 30, height:30, cursor: 'pointer', top: 10, zIndex: 10}}/>

					</div>

					<p
						onClick={() => navigate('/forgot-password')}
						style={{fontSize: 14, color: 'blue', textDecoration: 'underline', cursor: 'pointer'}}>Forgot Password</p>

					<CustomButtonContained
						text={'Submit'}
						onClick={onSubmitClicked}
					/>

				</div>

			</div>

		</main>
	);
}
